var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container message-template-page"},[_c('portal',{attrs:{"to":"page-name"}},[_vm._v("Modelos de mensagem")]),_c('div',{staticClass:"card card-page"},[_vm._m(0),_c('template-list',{staticClass:"card-body"})],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h1',{staticClass:"card-title"},[_vm._v("Modelos de mensagem")])])
}]

export { render, staticRenderFns }